<script>
  import { onMount } from 'svelte';
  import { footerLegalURL, footerCorporateURL } from './settings';

  let corporate = '';
  let legal = '';
  let loading = true;
  let error = false;

  onMount(async () => {
    try {
      const responseLegal = await fetch(footerLegalURL);
      legal = await responseLegal.text();
      const responseCorporate = await fetch(footerCorporateURL);
      corporate = await responseCorporate.text();
      loading = false;
    } catch(e) {
      console.warn(e);
      loading = false;
      error = true;
    }
  });
</script>
<div id="footer" class="footer">
  <div class="footer-wrapper vn">
    <div class="sources">
      <h3>Design e Sviluppo</h3>
      <p><a href="https://simonelippolis.com/" target="_blank">Simone Lippolis</a>.</p>
    </div>
    {#if !error}
      <div class="cols">
        <div class="legal col {loading ? 'loading' : ''}" id="footer-legal">
          <div class="footer-vn footer-vn-legal">{@html legal}</div>
        </div>
        <div class="corporate col {loading ? 'loading' : ''}" id="footer-corporate">
          <div class="footer-vn footer-vn-corporate">{@html corporate}</div>
        </div>
      </div>
    {/if}
    </div>
</div>

<style>
</style>